<template>
	<footer class="footer bg-light navbar fixed-bottom py-0 border-top" :style="{lineHeight: '0.8rem',fontSize:'0.7rem'} ">
	<!-- text-white navbar fixed-bottom -->
		<div class="container-xl" >
			<div class="row pb-2" v-if="false">
				<div class="col">
					<div class="row g-0 ms-auto small">
						<div class="mb-2">
							<div>
								<span><i class="bi bi-geo-alt-fill"></i></span>
								<span class="ms-1">地址</span>
								<span class="ms-1 fs-sm">106</span>
								<span class="ms-1">臺北市大安區復興南路2段268號5樓</span>
								<span>
									<a
										href="https://www.google.com.tw/maps/place/106%E5%8F%B0%E5%8C%97%E5%B8%82%E5%A4%A7%E5%AE%89%E5%8D%80%E5%BE%A9%E8%88%88%E5%8D%97%E8%B7%AF%E4%BA%8C%E6%AE%B5268%E8%99%9F5/@25.024696,121.5410187,17z/data=!3m1!4b1!4m5!3m4!1s0x3442aa2ec9cf3c1b:0xe00f3f1d0ee2d8d7!8m2!3d25.024696!4d121.5432074"
										target="_blank"
									>
									</a>
								</span>
							</div>
							<div>
								<span>5F., NO. 268, SEC. 2, FUXING S. RD., DA-AN DIST., TAIPEI CITY</span>
							</div>
							<div>
								<span class="fs-sm">106634, TAIWAN (R.O.C.)</span>
							</div>
							<div>
								<span><i class="bi bi-envelope"></i></span>
								<span class="ms-1">郵箱</span>
								<a class="text-secondary ms-2" href="mailto:giantleap@giantleap.com.tw">giantleap@giantleap.com.tw</a>
							</div>
							<div>
								<span><i class="bi bi-telephone-fill"></i></span>
								<span class="ms-1">電話</span>
								<a href="tel:+886-2-7711-3311" class="text-secondary ms-2">+886-2-7711-3311</a>
							</div>
							<div>
								<span><i class="bi bi-printer-fill"></i></span>
								<span class="ms-1">傳真</span>
								<span class="text-secondary ms-2">+886-2-2733-8033</span>
							</div>
						</div>
					</div>
				</div>
			</div>
			<div class="col-12 text-center">
				<small class="text-dark small">巨跡資訊 版權所有<span class="ms-1">©2023 Giantleap Company All Right Reserved.</span></small>
			</div>
		</div>
	</footer>
</template>
